// Match the API's saved-inquiry acknowledgement, not merely any successful HTTP response.
export const isInquirySaveConfirmed = (response) => (
  response?.status === 201 &&
  response.data !== null &&
  typeof response.data === "object" &&
  !Array.isArray(response.data) &&
  response.data.status === "success"
);

export const UNCONFIRMED_INQUIRY_MESSAGE =
  "We could not confirm that your inquiry was saved. Please contact HAQILA before submitting again.";